import { useTranslation } from '@thoughtspot/i18n';
import { BlinkErrorBoundary } from '@thoughtspot/mfe-utilities';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { IconColor, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Popover } from '@thoughtspot/radiant-react/widgets/popover';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useGetMessagesMetadata, useUpdateMessages, } from "../../../../services/coms/coms-service";
import { create } from "../../../../utils/logger";
import { useBlinkContextForCOMS, useValidateBlinkContextForCOMS, } from '../../../../contexts/coms-blink-context';
import styles from './notifications-container.module.scss';
const NotificationsContainer = React.lazy(() => import('./notifications.container'));
const logger = create('notifications-wrapper-container');
const POLLING_INTERVAL = 1000 * 60 * 2;
const USER_IDLE_TIMEOUT = 1000 * 60 * 5;
export const NotificationsWrapperContainer = () => {
    const { t } = useTranslation();
    useValidateBlinkContextForCOMS();
    const { sessionService } = useBlinkContextForCOMS();
    const isInAppNotificationEnabled = sessionService.isInAppNotificationEnabled();
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const notificationRef = useRef(null);
    const isNotificationVisible = isInAppNotificationEnabled && !sessionService.isCopilotEnabled();
    const { updateMessages, data, error } = useUpdateMessages();
    useValidateBlinkContextForCOMS();
    const [unseenNotifications, setUnseenNotifications] = useState(0);
    const { data: pollingResult, startPolling, stopPolling, } = useGetMessagesMetadata();
    useEffect(() => {
        startPolling(POLLING_INTERVAL);
        return () => {
            stopPolling();
        };
    }, []);
    useIdleTimer({
        timeout: USER_IDLE_TIMEOUT,
        onIdle: stopPolling,
        onActive: () => startPolling(POLLING_INTERVAL),
    });
    useEffect(() => {
        if (pollingResult && pollingResult.communicationMessagesMetadata) {
            setUnseenNotifications(pollingResult.communicationMessagesMetadata.unseenCount);
        }
    }, [pollingResult]);
    useEffect(() => {
        if (data?.unseenCount !== undefined &&
            data?.unseenCount !== unseenNotifications) {
            setUnseenNotifications(data?.unseenCount);
        }
    }, [data?.unseenCount]);
    useEffect(() => {
        if (error) {
            logger.error(error);
        }
    }, [error]);
    const resetMessages = () => {
        if (isInAppNotificationEnabled) {
            updateMessages({
                updateMessagesToUnread: true,
            });
        }
    };
    const inAppNotificationContent = (React.createElement(Vertical, { className: styles.notificationWrapperContainer },
        React.createElement(Typography, { variant: "content-label", className: styles.notificationWrapperHeading, onClick: (event) => event.stopPropagation() }, t('coms.userMenu.notifications')),
        React.createElement(NotificationsContainer, { resetMessages: resetMessages, closeProfileMenu: () => _.noop(), shouldFetchMessages: isNotificationOpen })));
    return (React.createElement(BlinkErrorBoundary, { handledErrors: ['*'] }, isNotificationVisible && (React.createElement(Horizontal, { hAlignContent: "right", className: styles.notificationIcon, onClick: () => {
            setIsNotificationOpen(!isNotificationOpen);
        } },
        React.createElement("div", { ref: notificationRef },
            React.createElement(Button, { icon: IconID.NOTIFICATION_BELL, size: IconSize.MEDIUM, iconColor: IconColor.WHITE, type: "secondary", text: "", backgroundType: "light", showBadge: unseenNotifications > 0, className: styles.bellIcon, "aria-label": "Notification Button", "aria-expanded": isNotificationOpen, "aria-haspopup": "menu" })),
        React.createElement(Popover, { targetRef: notificationRef, align: "bottom-end", isVisible: isNotificationOpen, content: inAppNotificationContent, onClickOutside: () => {
                setIsNotificationOpen(false);
                resetMessages();
            }, onEscape: () => {
                setIsNotificationOpen(false);
                resetMessages();
            }, bottomOffset: 8 })))));
};
//# sourceMappingURL=notifications-wrapper.container.js.map